/* eslint-disable react/destructuring-assignment */
import Icon from './Icon';

const CalendarFilledBatch = (props) => (
  <Icon {...props}>
    <path
      d="M6.0197 0.868601C6.0197 0.388886 5.62621 0 5.14081 0C4.65542 0 4.26193 0.388886 4.26193 0.868601V2.97227C2.51228 3.21673 1.13003 4.58442 0.896043 6.32902L0.794618 7.08523C0.777423 7.21344 0.76098 7.34172 0.74529 7.47006C0.703671 7.81052 0.975076 8.10695 1.32207 8.10695H20.6779C21.0249 8.10695 21.2963 7.81052 21.2547 7.47006C21.239 7.34172 21.2226 7.21343 21.2054 7.08522L21.104 6.32902C20.87 4.58444 19.4878 3.21677 17.7381 2.97228V0.868601C17.7381 0.388886 17.3446 0 16.8593 0C16.3739 0 15.9804 0.388886 15.9804 0.868601V2.79995C12.6667 2.50829 9.33336 2.50829 6.0197 2.79994V0.868601Z"
      fill={props.color}
    />
    <path
      d="M21.4817 10.3949C21.4714 10.0863 21.2134 9.84415 20.901 9.84415H1.09897C0.786587 9.84415 0.528587 10.0863 0.518328 10.3949C0.448722 12.4884 0.577393 14.5862 0.904026 16.6608C1.1513 18.2312 2.44227 19.4375 4.0427 19.5935L5.44072 19.7297C9.13794 20.0901 12.8621 20.0901 16.5593 19.7297L17.9573 19.5935C19.5577 19.4375 20.8487 18.2312 21.096 16.6608C21.4226 14.5862 21.5513 12.4884 21.4817 10.3949Z"
      fill={props.color}
    />
  </Icon>
);

export default CalendarFilledBatch;
